import React from 'react';
import { useStateSelector } from '../../../providers/stateManager';
import { selectImages } from '../../../utils/selectors';
import { stateKeys } from '../../../constants/stateKeys';
import Images from '../../Images';
import { useRemoveFile } from '../../../services/removeFileFromState';

const ImagesBlock = ({ commentId }) => {
  const images = useStateSelector(selectImages);

  const removeFile = useRemoveFile(stateKeys.images);

  if (!images?.length) return null;

  return <Images data={images} commentId={commentId} removeFile={removeFile} />;
};

export default ImagesBlock;
